export namespace Environment {
  export const firebase = {
    apiKey: "AIzaSyCml5OlTgOeENSLTbDjSMeWO2YBxIlzPuE",
    authDomain: "coflex-pro.firebaseapp.com",
    projectId: "coflex-pro",
    storageBucket: "coflex-pro.appspot.com",
    messagingSenderId: "718803293126",
    measurementId: "G-BRWWL18G7B",
    databaseURL: 'https://coflex-pro.firebaseio.com',
  };
  export const loading = { spinner: 'circles' };
  export const toast: { position: 'bottom' | 'top' | 'middle' } = { position: 'bottom' };
  export const toastDuration = 5000;
  export const firebaseRoomCollection: string = 'rooms/';
  export const firebaseUserCollection: string = 'users/';
  export const API_BASE_URL_V2 = 'https://api.empatica.io';
  export const API_LOYALITIX_BASE_URL = 'https://api.loyalitix.es';
  export const environmentStatus: 'prod' | 'demo' = 'prod';
  export const platform: 'mobile' | 'web' = 'mobile';
  export const CLIENT_ID = 86;
  export const AVAILABLE_LOGINS = ['ONE_STEP_LOGIN'];
  export const LOGIN_TERMS = false;
  export const AZURE_OAUTH_TENANT = null;
  export const AZURE_OAUTH_CLIENT_ID = null;
  export const AVAILABLE_LANGUAGES = ['es', 'pt', 'pl', 'en'];
  export const DEFAULT_LANGUAGE = 'es';
  export const COFLEX_API_KEY = '653faab32d3a7';
  export const REGISTER = false;
  export const DEEPLINK_SCHEME = 'coflex';
  export const DOCSBOT_API_KEY = 'ba10f6fa82d5b51561f5a548d19f74785dda71dbebfab310c55ed025b1017335';

}
